module.exports = __webpack_public_path__ + "static/media/ec2-icon.5803b096.svg";